<template>
   <div class="club">
    <div class="club__header">
      <h1 class="club__header--title">{{table.name}}</h1>
    </div>
    <div class="club__content">
      <p >DISPONIBLE: <b class="disponible disponi">{{table.available}}</b></p>
      <p >RESERVADO: <b class="reservado disponi">{{table.reserved}}</b></p>
     
    </div>
  </div>
</template>


<script>
export default {
    name: "TooltipAniversario",
    props: ["table"]
}
</script>
